/**
 * Document Type Enum
 *
 * Represents the type of document content detected through classification.
 * Used across workflow steps to determine processing logic.
 */
export enum DocumentType {
  PURCHASE_ORDER = "purchase_order",
  AP_INVOICE = "ap_invoice",
  AP_INVOICE_UPDATE = "ap_invoice_update",
  REMITTANCE_ADVICE = "remittance_advice",
  LEAD_TIME_SHEET = "lead_time_sheet",
  /** Carrier rate/load confirmation issued before pickup. Often a supporting doc for an AP invoice. */
  CARRIER_CONFIRMATION = "carrier_confirmation",
  /** Bill of Lading (straight or master) issued by carrier/shipper for in-transit freight. */
  BILL_OF_LADING = "bill_of_lading",
  /** Signed delivery receipt confirming goods were delivered (often a stamped/signed BOL). */
  PROOF_OF_DELIVERY = "proof_of_delivery",
  /** Document annotated with a receiving stamp/sticker indicating quantities received at the buyer's warehouse. */
  RECEIVING_STAMP = "receiving_stamp",
  /** A receipt (e.g. lumper/unloading receipt, misc service receipt) often attached to a freight/AP invoice as backup for a charge line. */
  RECEIPT = "receipt",
  OTHER = "other",
  /** Parent document that was split into multiple child documents. Not eligible for classification. */
  MULTI_DOC_PARENT = "multi_doc_parent",
}
